import { type ReactNode } from 'react';
import { dataLonga, nosUltimos30Dias } from '../lib/formato';

/**
 * `AvisoCampanha` (DESIGN-FOUNDATION §6.8) — nível 2, `--aviso-fraco`, hairline
 * `--aviso`. **Não é vermelho**: vermelho é ação, isto é informação. Só aparece
 * nos últimos 30 dias antes de `campanha_fim`. A metade tranquilizadora é
 * obrigatória (prazo real → comunicar é dever; UX §4.7).
 */
export function AvisoCampanha({ campanhaFim }: { campanhaFim: string | null }): ReactNode {
  if (!nosUltimos30Dias(campanhaFim)) return null;
  const data = campanhaFim ? dataLonga(campanhaFim) : '07/07/2027';
  return (
    <div className="rounded-2 border-l-2 border-aviso bg-aviso-fraco px-4 py-3">
      <p className="tipo-corpo text-tinta">
        O programa vai até <span className="tipo-corpo-forte text-tinta-forte">{data}</span>. Os
        vouchers que você já conquistou continuam valendo depois dessa data.
      </p>
    </div>
  );
}
